import cx from "classnames";
import type { Element } from "React";
import "./IconHomeActive.scss";
type Props = {
  className?: string;
  isActive: boolean;
};

const IconHomeActive = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={cx(props.className, "icon__icon-home-active")}
  >
    {props.isActive ? (
      <g fillRule="evenodd">
        <path d="M3.5 3.5h3v3h-3zM9.5 3.5h11v3h-11zM9.5 10.5h11v3h-11zM9.5 17.5h11v3h-11zM3.5 10.5h3v3h-3zM3.5 17.5h3v3h-3z" />
      </g>
    ) : (
      <g fill="none" fillRule="evenodd">
        <path d="M3.5 3.5h3v3h-3zM9.5 3.5h11v3h-11zM9.5 10.5h11v3h-11zM9.5 17.5h11v3h-11zM3.5 10.5h3v3h-3zM3.5 17.5h3v3h-3z" />
      </g>
    )}
  </svg>
);

export default IconHomeActive;
